import StackNavigator from '~navigators/StackNavigator';

import * as screens from './screens';

export default StackNavigator({
  initialRouteName: 'isNotViewingContent',
  screens,
});
